module.exports = __webpack_public_path__ + "img/championship-main-event-bg.ccc07f27.jpg";